import React, {useEffect, useState} from 'react';
import Modal from '../../cmp/Modal';
import BootStrapPagedTable from '../../cmp/BootStrapPagedTable';
import CurrencyNumber from '../../cmp/CurrencyNumber';
import {
    FormattedDate,
    FormattedMessage,
    FormattedNumber,
    FormattedTime,
} from 'react-intl';
import {get} from '../../../api';
import Label from '../../auth/components/Label';
import CopyButton from '../../cmp/CopyButton';
import Spinner from '../../cmp/Spinner';
import {connect} from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import Big from 'big.js';

const columns = [
    {
        title: 'Product',
        dataIndex: 'name'
    }, {
        title: 'Quantity',
        dataIndex: 'quantity',
        type: 'number',
        render: (quantity) => quantity || 1
    },
    {
        title: 'Price',
        type: 'number',
        dataIndex: 'total',
        render: (total) => <CurrencyNumber value={Number(total)}/>
    },
    {
        title: 'Commission',
        type: 'number',
        dataIndex: 'commission',
        render: (commission) => <CurrencyNumber value={Number(commission)}/>
    }
];

function AffiliateSalesLineItemsModal({order_id, onClose, show_shipping, show_customer, show_product}){
    const [visible, setVisible] = useState(false);
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        if(order_id){
            setVisible(true);
            setData({})
            setLoading(true);
            get('/sales/order_details',{
                    order_id
            }).then((data)=>{
                setData(data.data)
                setLoading(false);
            }).catch(()=>{
                setLoading(false);
            })
        }else{
            setVisible(false)
        }
    },[order_id])

    const { fulfillment_data, site_order_number,
        commission_adjustment, line_items, customer, order_value,
        affiliate_commission, discount_adjustment, shipping_address, shipping_price
    } = data;

    function hide() {
        setVisible(false);
        onClose()
    }

    return (
            <Modal visible={visible} onOk={hide} onClose={hide}
                   title={site_order_number ? String(site_order_number) : undefined}>
                {
                    loading ? <div className="text-center">
                        <Spinner/>
                    </div> : <>
                        <div className={'row mb-2'}>
                            <div className="col-6">
                                <div className={'p-2  bg-light rounded'}>
                                    <small>
                                        <strong><FormattedMessage id={"Order"}/></strong>
                                    </small>
                                    <div>{`${site_order_number}`}</div>
                                </div>
                            </div>
                            {
                                show_customer && customer &&
                                <RenderCustomer customer={customer} />
                            }
                        </div>
                        {
                            show_shipping && shipping_address &&
                            <div className="bg-light p-2 mb-2">
                                <strong><FormattedMessage id={"Shipping Address"}/></strong>
                                <ShopifyAddress {...shipping_address} />
                            </div>
                        }
                        <RenderFullfillment data={fulfillment_data}/>
                        <div className={'row mb-2'}>
                            <div className="col-6">
                                <div className={'p-2  bg-light rounded'}>
                                    <small>
                                        <strong><FormattedMessage id={"Order Total"}/></strong>
                                    </small>
                                    <div><CurrencyNumber value={Number(order_value)}/></div>
                                </div>
                            </div>
                            <div className="col-6 ">
                                <div className={'p-2 bg-light rounded'}>
                                    <small><strong><FormattedMessage id={"Commission"}/></strong></small>
                                    <div><CurrencyNumber value={affiliate_commission}/></div>
                                </div>
                            </div>
                        </div>

                        <table className="table table-striped">
                            {
                            show_product && line_items && <>
                                <thead>
                                    <tr>
                                        <th><FormattedMessage id={"Product"} /></th>
                                        <th  className={"text-right"}><FormattedMessage id={"Quantity"} /></th>
                                        <th  className={"text-right"}><FormattedMessage id={"Price"} /></th>
                                        <th  className={"text-right"}><FormattedMessage id={"Commission"} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    line_items.map((item)=>{
                                        return <tr key={String(item.name)}>
                                                <td>{item.name}</td>
                                                <td  className={"text-right"}>{item.quantity}</td>
                                            <td className={"text-right"}><CurrencyNumber value={item.total || 0} /></td>
                                            <td  className={"text-right"}>{affiliate_commission > 0 ? <CurrencyNumber value={item.commission || 0} /> : '-'}</td>
                                        </tr>
                                    })
                                }
                                {
                                    commission_adjustment && commission_adjustment.length > 0 ? <>
                                        <tr>
                                            <th colSpan={4}><FormattedMessage id={"Adjustments"} /></th>
                                        </tr>
                                        <RenderCommissionAdjustments
                                            commission_adjustment={commission_adjustment}/>
                                        </> :
                                        null
                                }
                                </tbody>
                            </>
                        }
                         </table>
                        {
                            show_product && shipping_price !== undefined ?
                                <div className="d-flex justify-content-between">
                                    <span><FormattedMessage id={"Shipping"}/></span>
                                    <span><CurrencyNumber value={shipping_price}/></span>
                                </div> : null
                        }
                        {
                            data.coupons && Array.isArray(data.coupons) && data.coupons.length > 0 ?
                                <div className="d-flex justify-content-between">
                                    <span><FormattedMessage id={"couponCode"}/></span>
                                    <span>{data.coupons ? data.coupons.join(",") : null}</span>
                                </div> : null
                        }
                        {
                            show_product && discount_adjustment ? <div className="d-flex justify-content-between">
                                <span><FormattedMessage id={"Discount Adjustment"}/></span>
                                <span className="text-danger"><CurrencyNumber value={discount_adjustment}/></span>
                            </div> : null
                        }
                    </>
                }
            </Modal>
        );
}

function RenderCustomer({customer, customer_email, phone, customer_name}){
    const {name, first_name, last_name, orders_count, email} = customer || {};
    const n = [first_name || '', last_name || ''].filter((item)=>item).join(" ");
    return  <div className="col-6">
        <div className={'p-2 bg-light rounded'}>
            <small><strong><FormattedMessage id={"Customer"}/></strong></small>
            <div>{customer_name || name || n || "-"}
                <RenderNew
                    orders_count={orders_count}/>
            </div>
            <small className={"gdpr_sensitive_info"}>{customer_email || email || phone || customer.phone}</small>
        </div>
    </div>
}

function ShopifyAddress({name, address1, address_1, address2, address_2, company, phone, city, zip, state, province, country}) {
    return <div>
        <div>{name}</div>
        <div className="gdpr_sensitive_info">
        <div>{company}</div>
        <div>{address1 || address_1}</div>
        <div>{address2 || address_2}</div>
        <div>{city}, {province || state} {zip}</div>
        {phone && <div>{phone}</div>}
        </div>
    </div>
}

function RenderNew({orders_count}) {
    switch (orders_count) {
        case 1:
            return <span className={"ml-2 badge badge-secondary"}><FormattedMessage id={"NEW"} defaultMessage={"NEW"}/></span>
        default:
            return null;
    }
}

function RenderFullfillment({data, loading}) {
    if (loading) {
        return <div className="py-2">
            <Skeleton height={100}/>
        </div>
    }
    if (!data) {
        return null;
    }
    if (data.length === 0) {
        return <div className={"bg-light p-2 mb-2"}>
            <Label>Shipping Status</Label>
            <h3>Processing</h3>
        </div>
    }
    return <>
        <div className="bg-light mb-2 rounded border">
            {
                data.filter((item) => ['cancelled', 'error', 'failure']
                    .indexOf(item.status) === -1)
                    .map((item) => {
                        const {
                            id, tracking_company, status, shipment_status, tracking_numbers, tracking_urls, created_at, updated_at
                        } = item;
                        if (!id) return null;
                        return <div key={id} className={"p-2"}>

                            <div className="d-flex justify-content-between align-items-start">
                                <strong>Shipping status</strong>
                                <span>
                                    <FormattedTime value={created_at} minute={"2-digit"} hour={"2-digit"} hour12 />
                                    <span className={"mx-1"}/>
                                    <FormattedDate value={created_at} weekday={"short"} month={"short"} day={"2-digit"}/></span>
                            </div>
                            <h4><RenderShipmentStatus shipment_status={shipment_status}/></h4>
                            <div className={"lead mt-2"}>{tracking_company}</div>
                            <Label>
                                <FormattedMessage id={"tracking_number"}
                                                  defaultMessage={`Tracking {numbers, plural, one {Number} other {Numbers}}`}
                                                  values={{numbers: tracking_numbers.length}}/></Label>
                            <p>{tracking_numbers.map((item) => <div key={item}>{item}</div>)}</p>
                            <Label>
                                <FormattedMessage id={"tracking_number"}
                                                  defaultMessage={`Tracking {numbers, plural, one {Link} other {Links}}`}
                                                  values={{numbers: tracking_urls.length}}/>
                            </Label>
                            <div>{
                                tracking_urls.map((item) => <div className={"d-flex align-items-center"}>
                                    <CopyButton text={item} title={"Copy Link"}/>
                                    <a href={item} target={"_blank"} className={"ml-4"} rel={"noopener nofollow"}
                                       key={item}>Open Link</a>
                                </div>)
                            }
                            </div>
                        </div>
                    })
            }
        </div>
    </>
}

function RenderShipmentStatus({shipment_status}) {
    switch (shipment_status) {
        case "label_printed":
        case "label_purchased":
            return "Processing";
        case "attempted_delivery":
            return "Delivery attempted";
        case "ready_for_pickup":
            return "Ready for pickup";
        case "confirmed":
            return "Shipping Confirmed"
        case "in_transit":
            return "In Transit"
        case "out_for_delivery":
            return "Out for delivery"
        case "delivered":
            return <span className={"text-success"}>Delivered</span>
        case "failure":
            return <span className={"text-danger"}>Delivery Failed</span>
        default:
            return "";
    }
}


function mapStateToProps(state) {
    const {aff_order_details_table_info, aff_show_order_fulfillment} = state.settings;
    let show_product = true;
    let show_shipping = true;
    let show_customer = true;
    let show_fulfillment = aff_show_order_fulfillment;
    if (aff_order_details_table_info) {
        const opts = JSON.stringify(aff_order_details_table_info);
        show_product = opts.indexOf('product') > -1
        show_shipping = opts.indexOf('shipping') > -1;
        show_customer = opts.indexOf('customer') > -1
        show_fulfillment = opts.indexOf('fulfillment') > -1
    }

    return {
        show_product, show_customer, show_shipping, show_fulfillment
    }
}



function RenderCommissionAdjustments({commission_adjustment}) {

    return commission_adjustment.filter((item) => item.value).map((item, index) => {
            const vals = getAdjustmentValues(item);
            if (vals && vals.length > 0) {
                return <RenderAdjustmentRow title={vals[0]}
                                            adjustment={<RenderCommission
                                                commission_type={item.commission_type ||
                                                    'percentage'}
                                                commission_value={item.commission_value ||
                                                    100}/>
                                            } desc={vals[1]} key={String(index)}/>;
            } else {
                return null;
            }

        })

}

function RenderCommission({commission_type, commission_value}){
    switch (commission_type) {
        case "percentage":
            return <span><FormattedNumber value={commission_value} />%</span>;
        case "flat_rate":
            return <CurrencyNumber value={commission_value} />;
        case "fixed_amount_on_order":
            return <span><CurrencyNumber value={commission_value} /> per order</span>
        default:
            return null;
    }
}


function getAdjustmentValues({value, source, matcher}) {
    switch (source) {
        case "commission_booster":
            return ["Bonus", value];
        case 'exclude_self_referral':
            return [source, value, 'percentage', 100];
        case 'order_value_gteq':
            return [
                <span>Order value {`>=`} <CurrencyNumber value={matcher}/></span>,
                value];
        case 'order_value_lteq':
            return [
                <span>Order value {`<=`} <CurrencyNumber value={matcher}/></span>,
                value];
        case 'shipping_state':
            return [`Shipping state matches ${matcher}`, value];
        case 'shipping_country':
            return [`Shipping country matches ${matcher}`, value];
        case 'is_new_customer':
            return ['New customer', value];
        case 'is_old_customer':
            return ['Old Customer', value];
        case 'shipping_adjustment':
            return ['Shipping Adjustment', value];
        case 'discount_adjustment':
            return ['Discount Adjustment', value];
        case 'vat_adjustment':
            return ['VAT Adjustment', value];
        case 'affiliate_first_sale':
            return ['Affiliate\'s first sale', value];
        case 'product_name':
            return [`Product ~ ${matcher}`, value];
        case 'coupon_code':
            return [`Coupon Code ~ ${matcher}`, value];
        case 'custom_adjustment':
            return ['Custom Adjustment', value];
        default:
            return [source, value];
    }
}

function RenderAdjustmentRow({adjustment, title, desc}) {
    if (Math.round(Number(desc || 0) * 100) / 100 === 0) {
        return null;
    }
    return <tr>
        <td colSpan={2}>
            <span>{title}</span>
        </td>
        <td colSpan={1}>
            {adjustment}
        </td>
        <td className={'text-right'}>
            {
                Big(desc || 0).gte(0) ? <span className={'text-success'}>
                    <CurrencyNumber value={desc}/>
                </span> : <span className={'text-danger'}>
                    <CurrencyNumber value={desc}/>
                </span>
            }
        </td>
    </tr>;

}

export default connect(mapStateToProps)(AffiliateSalesLineItemsModal);
